module.exports = __webpack_public_path__ + "img/12.9ccf74fb.png";